import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";

import setAuthToken from "./utils/api/token";

import NotFound from "./views/errors/404";
import SecureRoutes from "./routing/secure";
import Tokenize from "./views/tokenize";
import PublicSign from "./views/public/sign";
import EmailOptOut from "./views/public/email/optout";

import { get as getUser, logout } from "./actions/auth";

export const App = ({ getUser, logout }) => {

  const [hydrated, setHydrated] = useState(false);
  async function __getUser() {
    try { await getUser(); } finally { setHydrated(true); }
  }

  async function __logout() {
    await logout();
  }
  useEffect(() => {
    const incomingSession = window.location.pathname.replace(/\/+$/, "") === "/authentic/tokenize";
    if (localStorage.token && !incomingSession) {
      setAuthToken(localStorage.token);
      __getUser();
    } else {
      setHydrated(true); // nothing to hydrate
    };

    // log user out from all tabs if they log out in one tab
    const onStorage = () => {
      if ((!localStorage.token) || (!localStorage.instance)) __logout();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  
  }, []);

  return (
    
    <BrowserRouter>
      {hydrated && (
        <Routes>
          <Route exact path="/authentic/tokenize" element={<Tokenize />} />
          <Route exact path="/public/sign/:token" element={<PublicSign />} />
          <Route exact path="/public/email/optout" element={<EmailOptOut />} />
          <Route path="/dashboard/*" element={<SecureRoutes />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      )}
    </BrowserRouter>
  );
};

export default connect(null, { getUser, logout })(App);
